<template>
    <section class="p-2 widget my-2">
        <div class="row">
            <div class="col-12">
                <a
                    class="font-weight-bold float-right "
                    :class="
                        canEditClientEmr
                            ? 'text-primary cursor-pointer'
                            : 'text-muted cursor-not-allowed'
                    "
                    @click="canEditClientEmr ? editTraits() : null"
                    >Edit</a
                >

                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0">Things to look out for</p>
                    <ul>
                        <li v-for="t in patient.things_to_look_out_for">{{ t }}</li>
                    </ul>
                </div>
                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0 mt-2">Reinforcers</p>
                    <ul>
                        <li v-for="t in patient.reinforcers">{{ t }}</li>
                    </ul>
                </div>
                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0 mt-2">Special requests</p>
                    <ul>
                        <li v-for="t in patient.special_conditions">{{ t.description }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <modal-component
            :id="'patient-traits'"
            :title="modal.title"
            :visible="modal.visible"
            @close="resetModal()"
        >
            <div class="">
                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0">Things to look out for</p>
                    <div class="form-group row mb-1">
                        <div class="form-group col-10 mb-1">
                            <input
                                type="text"
                                v-model="things_to_look_out_for"
                                class="form-control-sm form-control"
                            />
                        </div>
                        <div class="form-group col-2 mb-1">
                            <button
                                class="btn btn-sm btn-primary font-weight-bold text-uppercase link-primary text-white"
                                @click="addItem('things_to_look_out_for')"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(t, i) in payload.things_to_look_out_for" class="mb-0">
                            {{ t }}
                            <i
                                v-tooltip="`Remove`"
                                class="fa fa-trash-o text-danger cursor-pointer ml-2"
                                @click="removeItem('things_to_look_out_for', i)"
                            ></i>
                        </li>
                    </ul>
                </div>
                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0 mt-2">Reinforcers</p>
                    <div class="form-group row mb-1">
                        <div class="form-group col-10 mb-1">
                            <input
                                type="text"
                                v-model="reinforcers"
                                class="form-control-sm form-control"
                            />
                        </div>
                        <div class="form-group col-2 mb-1">
                            <button
                                class="btn btn-sm btn-primary font-weight-bold text-uppercase link-primary text-white"
                                @click="addItem('reinforcers')"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(t, i) in payload.reinforcers" class="mb-0">
                            {{ t }}
                            <i
                                v-tooltip="`Remove`"
                                class="fa fa-trash-o text-danger cursor-pointer ml-2"
                                @click="removeItem('reinforcers', i)"
                            ></i>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p class="text-uppercase font-weight-bold mb-0 mt-2">Special requests</p>
                        <vw-multi-select
                            id="cpt_code"
                            v-model="payload.special_conditions"
                            :styles="{ input: { width: '100%' } }"
                            :template="'bootstrap'"
                            :iconset="'font-awesome'"
                            :list="specialConditions"
                            :value-property="'id'"
                            :searchable="true"
                            :tags="false"
                            :selected-list-display-function="item => item.description"
                            :list-item-display-function="item => item.description"
                        ></vw-multi-select>
                    </div>
                </div>
                <button
                    class="btn btn-sm btn-primary text-white font-weight-bold float-right text-uppercase mt-3"
                    @click.prevent="saveTraits()"
                >
                    Save
                </button>
            </div>
        </modal-component>
    </section>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
import { permissions } from "../../plugins/permissions";

export default {
    name: "PatientTraits",
    props: ["patient", "specialConditions"],
    mixins: [permissions],
    components: { ModalComponent },
    data() {
        return {
            modal: {
                visible: false,
                title: "Edit Patient Traits",
            },
            payload: {
                things_to_look_out_for: [],
                reinforcers: [],
                special_conditions: [],
            },
            things_to_look_out_for: null,
            reinforcers: null,
        };
    },
    methods: {
        editTraits() {
            this.modal.visible = true;
            this.payload.things_to_look_out_for = this.patient.things_to_look_out_for
                ? [...this.patient.things_to_look_out_for]
                : [];
            this.payload.reinforcers = this.patient.reinforcers
                ? [...this.patient.reinforcers]
                : [];
            this.patient.special_conditions.forEach(s => {
                this.payload.special_conditions.push(s.id);
            });
        },

        resetModal() {
            this.modal.visible = false;
            this.things_to_look_out_for = [];
            this.reinforcers = [];
            this.payload = {
                things_to_look_out_for: [],
                reinforcers: [],
                special_conditions: [],
            };
        },

        addItem(list) {
            this.payload[list].push(this[list]);
            this[list] = null;
        },

        removeItem(list, index) {
            this.payload[list].splice(index, 1);
        },

        saveTraits() {
            if (!this.canEditClientEmr) return;
            const payload = { ...this.payload };
            axios
                .patch(`/api/patients/${this.patient.id}`, payload)
                .then(r => {
                    this.$emit("patient-saved");
                    this.resetModal();
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped lang="scss">
/*.trait-list {
        > ul {
            list-style: none;
        }
    }*/
</style>
